import { useState, useRef } from "react";
import downBackgroundImage from "../static/downBackgroundImage.svg";
import accountImage from "../static/Account.svg";
import background from "../static/background.png";
import logoImage from "../static/logo.svg";
import { Link } from "react-router-dom";

export default function Form({ sumPoints, user, demoMode }) {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [url, setUrl] = useState("");
  const [size, setSize] = useState("");
  const [count, setCount] = useState("");
  const [promocode, setPromocode] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notification, setNotification] = useState("");
  const [hideNotification, setHideNotification] = useState(false);

  const orderApiUrl = process.env.REACT_APP_ORDER_API_URL;

  // Создаем рефы для инпутов
  const addressRef = useRef(null);
  const urlRef = useRef(null);
  const sizeRef = useRef(null);
  const countRef = useRef(null);
  const promocodeRef = useRef(null);

  const showNotification = (text) => {
    setNotification(text);
    setHideNotification(false);

    setTimeout(() => setHideNotification(true), 4000);
    setTimeout(() => setNotification(""), 5000);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    if (
      !name.trim() ||
      !address.trim() ||
      !url.trim() ||
      !size.trim() ||
      !count.trim()
    ) {
      showNotification("❌ Пожалуйста, заполните все обязательные поля.");
      return;
    }

    setIsSubmitting(true);

    try {
      if (!demoMode) {
        if (!orderApiUrl) {
          throw new Error("Не настроен backend endpoint для заказов");
        }

        const response = await fetch(orderApiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user_id: user.id,
            username: user.username,
            name,
            address,
            url,
            size,
            count,
            promocode: promocode || null,
          }),
        });

        if (!response.ok) {
          throw new Error(`Ошибка HTTP ${response.status}`);
        }
      }

      setName("");
      setAddress("");
      setUrl("");
      setSize("");
      setCount("");
      setPromocode("");

      showNotification("✅ Заказ отправлен! Наш менеджер свяжется с вами.");
    } catch (error) {
      console.error("Ошибка при отправке заказа:", error);
      showNotification("❌ Ошибка при отправке заказа. Попробуйте позже.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef) {
        nextRef.current.focus();
      } else {
        handleSubmit();
      }
    }
  };

  return (
    <div className="form">
      <img
        src={downBackgroundImage}
        alt="backgroundImage"
        className="background-image"
      />
      <img src={background} alt="background" className="background" />

      <div className="form__container">
        <div className="header-block">
          <header>
            <Link to="https://minishopghost.netlify.app/account">
              <img src={accountImage} alt="account" />
            </Link>
            <p>{sumPoints}</p>
          </header>
          <Link to="/" className="close">
            ← Назад
          </Link>
        </div>

        <h1>ОФОРМЛЕНИЕ ЗАКАЗА</h1>

        <div className="form-inputs">
          <p>ВВЕДИТЕ ДАННЫЕ О ТОВАРЕ</p>
          <input
            type="text"
            placeholder="Наименование*"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, addressRef)}
          />
          <input
            ref={addressRef}
            type="text"
            placeholder="Адрес*"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, urlRef)}
          />
          <input
            ref={urlRef}
            type="text"
            placeholder="Ссылка*"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, sizeRef)}
          />
          <input
            ref={sizeRef}
            type="text"
            placeholder="Размер*"
            value={size}
            onChange={(e) => setSize(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, countRef)}
          />
          <input
            ref={countRef}
            type="text"
            placeholder="Количество*"
            value={count}
            onChange={(e) => setCount(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, promocodeRef)}
          />
          <input
            ref={promocodeRef}
            type="text"
            placeholder="Промокод"
            value={promocode}
            onChange={(e) => setPromocode(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e, null)}
          />
          <button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Отправка..." : "ЗАКАЗАТЬ"}
          </button>
        </div>

        {notification && (
          <p className={`notification ${hideNotification ? "hide" : ""}`}>
            {notification}
          </p>
        )}

        <p className="manager">
          Наш менеджер свяжется с вами в ближайшее время
        </p>
      </div>

      <img src={logoImage} alt="logo" className="logo" />
    </div>
  );
}
